module.exports = __webpack_public_path__ + "static/media/invoiceIncoming.b28908a9.svg";